// extracted by mini-css-extract-plugin
module.exports = {"layer":"_1J62uncBIpifJ_LIdpE2q3"};